(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoUAEVRegenerarService', ReporteEvaluativoUAEVRegenerarService);

    ReporteEvaluativoUAEVRegenerarService.$inject = ['$resource'];

    function ReporteEvaluativoUAEVRegenerarService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/regenerarreporteUAEV:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
            'regenerar': {
            	method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteuaevregenerar:id',
            	method:'PUT' 
            }
        });
    }
})();
